<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36.21 36.21"
  >
    <path
      class="cls-1"
      d="M34.62,16.51h-14.91V1.6c0-.88-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6v14.91H1.6c-.88,0-1.6.72-1.6,1.6s.72,1.6,1.6,1.6h14.91v14.91c0,.88.72,1.6,1.6,1.6s1.6-.72,1.6-1.6v-14.91h14.91c.88,0,1.6-.72,1.6-1.6s-.72-1.6-1.6-1.6Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
